<template>
  <p v-if="label" :class="computedLabelClasses">
    <span>{{ label }}</span>
    <span v-if="required || validations?.required" class="text-negative">
      *
    </span>
    <PTooltip
      v-if="helpOnHover"
      anchor="bottom left"
      self="top left"
      :offset="[0, 4]"
      class="text-sm"
      max-width="500px"
    >
      {{ help }}
    </PTooltip>
  </p>
  <p v-if="help && !helpOnHover" :class="helpClasses">
    <span v-html="help"></span>
  </p>
  <q-field
    ref="component"
    v-bind="$attrs"
    :rules="validationRules"
    borderless
    no-error-icon
  >
    <template
      v-for="(slot, index) of Object.keys($slots)"
      :key="index"
      #[slot]="slotProps"
    >
      <slot v-bind="slotProps" :name="slot"></slot>
    </template>
  </q-field>
</template>

<script setup>
import { isEmpty } from "assets/scripts/utilities/helpers";
import validationsToRules from "assets/scripts/utilities/validations";

const props = defineProps({
  label: {
    type: String,
    default: "",
  },
  labelClasses: {
    type: String,
    default: "text-sm text-neutral",
  },
  help: {
    type: String,
    default: "",
  },
  helpClasses: {
    type: String,
    default: "text-neutral-70 q-mb-xs text-xs",
  },
  helpOnHover: {
    type: Boolean,
    default: false,
  },
  required: {
    type: Boolean,
    default: false,
  },
  rules: {
    type: Array,
    default: () => {
      return [];
    },
  },
  validations: {
    type: Object,
    default: () => {
      return {};
    },
  },
});

const computedLabelClasses = computed(() => {
  return `${props.labelClasses} ${props.help ? "q-mb-none" : "q-mb-xs"}`;
});

const component = ref(null);

defineExpose({
  component,
});

const validationRules = computed(() => {
  if (props.required || !isEmpty(props.validations) || props.rules.length) {
    return [
      ...validationsToRules({
        label: props.validations?.label || props.label,
        required: props.required || props.validations?.required,
        ...props.validations,
      }),
      ...props.rules,
    ];
  }

  return [];
});
</script>

<style lang="scss" scoped>
.q-field {
  :deep(.q-field__inner) {
    .q-field {
      &__control,
      &__native {
        min-height: 38px;
      }
    }
  }

  &--dense {
    :deep(.q-field__inner) {
      .q-field {
        &__control,
        &__native {
          min-height: 30px;
        }
      }
    }
  }
}
</style>
